import Joyride, { ACTIONS, EVENTS, ORIGIN, STATUS, CallBackProps, Step } from 'react-joyride';
import { useSetState } from 'react-use';
import { Box } from '@mui/material'
import { useEffect } from 'react';
import { application } from 'express';
'./i18n/config';
import { useTranslation, Trans } from 'react-i18next';
import { useIsMobile } from './hooks/useIsMobile';
export function Onboarding(params: any) {
    const { startOnBoarding = false, onOnboardingStarted = () => { }, setShowCanopySidePanel = () => { }, setShowMobileMenu = () => { }, setShowAdditionalMobileMenu = () => { }, ...rest } = params;
    const isMobile = useIsMobile();

    interface State {
        run: boolean;
        stepIndex: number;
        steps: Step[];
    }

    const [{ run, stepIndex, steps }, setState] = useSetState<State>({
        run: false,
        stepIndex: 0,
        steps: [],
    });

    useEffect(() => {
        if (startOnBoarding) {
            setState({ run: startOnBoarding, stepIndex: 0 });
            onOnboardingStarted();
        }
    }, [startOnBoarding]);
    const { t, i18n } = useTranslation();
    useEffect(() => {
        const mobileSteps = [
            {
                target: '#root',
                content: t('onboarding.welcome'),
                disableBeacon: true,
                data: {
                    callExit: () => {
                        setShowAdditionalMobileMenu(true)
                    }
                }
            },
            {
                target: '#map-layer-button',
                placement: 'left',
                content: t('onboarding.map_layers'),
            },
            {
                target: '.mobile-menu-toggle',
                content: t('onboarding.buttons'),
            },
            {
                target: '#find-canopy-button',
                content: t('onboarding.find_canopy_button'),
                data: {
                    callExit: () => {
                        setShowCanopySidePanel(true)
                    }
                }
            },
            {
                target: '#cutaway-parameters-div',
                content: t('onboarding.cutaway_parameters')
            },
            {
                target: '#cutaway-location-div',
                content: t('onboarding.location_button'),
            },
            {
                target: '#cutaway-height-div',
                content: t('onboarding.altitude_controls'),
            },
            {
                target: '#cutaway-sink-rate-div',
                content: t('onboarding.sink_rate_controls'),
            },
            {
                target: '#cutaway-time-div',
                content: t('onboarding.sink_time_controls')
            },
            {
                target: '#cutaway-date-div',
                content: t('onboarding.cutaway_date')
            }
        ];

        const desktopSteps = [
            {
                target: '#root',
                content: t('onboarding.welcome'),
                disableBeacon: true,
            },
            {
                target: '#map-layer-button',
                placement: 'left',
                content: t('onboarding.map_layers'),
            },
            {
                target: '#canopy-buttons-div',
                content: t('onboarding.buttons'),
            },
            {
                target: '#find-canopy-button',
                content: t('onboarding.find_canopy_button'),
                data: {
                    callExit: () => {
                        setShowCanopySidePanel(true)
                    }
                }
            },
            {
                target: '#cutaway-parameters-div',
                content: t('onboarding.cutaway_parameters')
            },
            {
                target: '#cutaway-location-div',
                content: t('onboarding.location_button'),
            },
            {
                target: '#cutaway-height-div',
                content: t('onboarding.altitude_controls'),
            },
            {
                target: '#cutaway-sink-rate-div',
                content: t('onboarding.sink_rate_controls'),
            },
            {
                target: '#cutaway-time-div',
                content: t('onboarding.sink_time_controls')
            },
            {
                target: '#cutaway-date-div',
                content: t('onboarding.cutaway_date')
            }
        ];

        setState(prevState => ({
            ...prevState,
            steps: isMobile ? mobileSteps : desktopSteps
        }))
    }, [isMobile, i18n.language, t, setShowMobileMenu, setShowCanopySidePanel, setShowAdditionalMobileMenu])


    const handleJoyrideCallback = (data: CallBackProps) => {
        const { action, index, origin, status, type } = data;
        if (EVENTS.STEP_BEFORE === type) {
            if (data.step.data && data.step.data.callEnter) {
                data.step.data.callEnter()
            }
        }

        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
            // Update state to advance the tour
            //setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
            const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
            if (data.step.data && data.step.data.callExit) {
                data.step.data.callExit()
                setState({
                    run: false,
                    stepIndex: nextStepIndex,
                });

                // Need to wait until the exit function is done before we start the tour again.
                setTimeout(() => {
                    setState({ run: true });
                }, 400);
            } else {
                setState({
                    run: true,
                    stepIndex: nextStepIndex,
                });
            }

        } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            // You need to set our running state to false, so we can restart if we click start again.
            setState({ run: false, stepIndex: 0 });
        }
    };

    return (
        <Box minHeight="90vh">
            <Joyride
                callback={handleJoyrideCallback}
                run={run}
                steps={steps}
                continuous={true}
                showProgress={true}
                showSkipButton={true}
                stepIndex={stepIndex}
                styles={{
                    options: {
                        arrowColor: 'rgb(0, 79, 176)',
                        backgroundColor: 'rgba(208, 208, 208, 0.97)',
                        overlayColor: 'rgb(105, 105, 105)',
                        primaryColor: 'rgba(62, 102, 212, 0.98)',
                        textColor: 'rgb(0, 0, 0)',
                        zIndex: 10000,
                    },  
                }}
                locale={{
                    back: t('joyride.back'),
                    close: t('joyride.close'),
                    last: t('joyride.last'),
                    next: t('joyride.next'),
                    skip: t('joyride.skip'),
                    nextLabelWithProgress: t('joyride.nextLabelWithProgress'),
                    open: t('joyride.open')
                }}
            />
        </Box>
    );
}
